module.exports = __webpack_public_path__ + "img/hb-1.380fc467.png";